import { SHA256, enc } from "crypto-js";
import { json } from "../json";


export const uniqueId = SHA256(JSON.stringify(json)).toString(enc.Hex);